import { api } from '@/services/api/AxiosBaseService'
import type { SingleResponse } from '@/types/api'

export type ProposalSlot = 'cover' | 'body' | 'back_cover' | 'manual_cover' | 'manual_back_cover'

export interface ProposalTemplateSlot { present: boolean; url: string | null }

export interface ProposalTemplate {
  id: string
  defaultObservations: string | null
  cover: ProposalTemplateSlot
  body: ProposalTemplateSlot
  backCover: ProposalTemplateSlot
  manualCover: ProposalTemplateSlot
  manualBackCover: ProposalTemplateSlot

  // Dados da CONTRATADA (Ampla) — cabeçalho "Dados das partes".
  contractorName: string | null
  contractorDocument: string | null
  contractorAddress: string | null
  contractorPostalCode: string | null
  contractorCity: string | null
  contractorState: string | null
  contractorEmail: string | null
  contractorPhone: string | null

  // Padrões das cláusulas — copiados para a proposta na criação.
}

/** Campos gravados pelo PUT (tudo opcional). */
export interface ProposalTemplatePayload {
  defaultObservations?: string | null
  contractorName?: string | null
  contractorDocument?: string | null
  contractorAddress?: string | null
  contractorPostalCode?: string | null
  contractorCity?: string | null
  contractorState?: string | null
  contractorEmail?: string | null
  contractorPhone?: string | null
}

const BASE = '/settings/commercial/proposal-templates'

export const ProposalTemplatesService = {
  async get(): Promise<ProposalTemplate> {
    const r = await api.get<SingleResponse<ProposalTemplate>>(BASE)
    return r.data.data
  },
  async updateObservations(html: string | null): Promise<ProposalTemplate> {
    const r = await api.put<SingleResponse<ProposalTemplate>>(BASE, { defaultObservations: html })
    return r.data.data
  },
  /** Grava dados da contratada e/ou padrões das cláusulas. */
  async update(payload: ProposalTemplatePayload): Promise<ProposalTemplate> {
    const r = await api.put<SingleResponse<ProposalTemplate>>(BASE, payload)
    return r.data.data
  },
  async upload(slot: ProposalSlot, file: File): Promise<ProposalTemplate> {
    const fd = new FormData()
    fd.append('slot', slot)
    fd.append('file', file)
    const r = await api.post<SingleResponse<ProposalTemplate>>(BASE, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return r.data.data
  },
  async remove(slot: ProposalSlot): Promise<ProposalTemplate> {
    const r = await api.delete<SingleResponse<ProposalTemplate>>(BASE, { data: { slot } })
    return r.data.data
  },
}
